import Vue from 'vue'
import App from './App.vue'
import { router, i18n } from './_helpers'
import store from './_store'
import VueCookies from 'vue-cookies'
import 'vuetify/dist/vuetify.min.css'
import vuetify from '@/plugins/vuetify'
import HighchartsVue from 'highcharts-vue'
import Highcharts from 'highcharts'
import highchartsMore from 'highcharts/highcharts-more'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSpinner, faHourglassHalf, faFileSignature } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate';

Vue.component('validation-provider', ValidationProvider);
Vue.component('validation-observer', ValidationObserver);
library.add(faSpinner, faHourglassHalf, faFileSignature)

Vue.component('font-awesome-icon', FontAwesomeIcon)

import { required, numeric,integer, min, max, min_value, max_value, alpha_num, regex, email, length } from 'vee-validate/dist/rules'
extend('regex',{...regex})
extend('alpha_num',{...alpha_num})
extend('numeric',{...numeric})
extend('integer',{...integer})
extend('min_value',{...min_value})
extend('max_value',{...max_value})
extend('min',{...min})
extend('max',{...max})
extend('required', {...required});
extend('email', {...email});
extend('length', {...length});

Vue.use({ Highcharts })
Vue.config.productionTip = false
highchartsMore(Highcharts)
Vue.use(HighchartsVue)

export const EventBus = new Vue()
export const dashboardMixIn = {
  methods: {
    $translatedErrorMessages: function (errors, name, replacements) {
        if (undefined === replacements) {
            replacements = []
        }
      if (errors && Object.keys(errors).length > 0) {
        for (let [key] of Object.entries(errors)) {
          return this.$t(`msg.${name}_error_${key}`.toString().toLowerCase(), replacements)
        }
      }
    }
  }
}

document.title = 'GFI'
Vue.config.productionTip = false
Vue.use(VueCookies)
Vue.mixin(dashboardMixIn)
new Vue({
    router,
    store,
    i18n,
    vuetify,
  render: h => h(App)
}).$mount('#app')
